import Modal from "react-modal";
const LoadingComponent = (props) => {
  Modal.setAppElement("#root");
  return (
    <div>
      <Modal
        isOpen={props.isLoading}
        style={{
          overlay: { zIndex: 100, backgroundColor: "#ffffff80" },
          content: {
            backgroundColor: "transparent",
            width: 200,
            borderWidth: 0,
            height: 200,
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          },
        }}
      >
        {/* <div className="loader"></div> */}
        <div class="psoload">
          <div class="straight"></div>
          <div class="curve"></div>
          <div class="center"></div>
          <div class="inner"></div>
        </div>
      </Modal>
    </div>
  );
};

export default LoadingComponent;
